import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "staff-page" }
const _hoisted_2 = {
  key: 0,
  class: "page-heading property-hero"
}
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = { class: "hero-title" }
const _hoisted_5 = { class: "page-actions" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "action-menu" }
const _hoisted_8 = {
  "aria-label": "Дополнительные действия",
  title: "Дополнительные действия"
}
const _hoisted_9 = { class: "action-menu-content" }
const _hoisted_10 = { class: "space-y-5" }
const _hoisted_11 = { class: "flex items-center justify-between gap-2 mb-2" }
const _hoisted_12 = { class: "flex items-center justify-between gap-2 mb-2" }
const _hoisted_13 = {
  key: 2,
  class: "staff-toast",
  role: "status"
}

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { BookOpen, Ellipsis, CodeXml, Link, Copy } from '@lucide/vue';

import { ref, onMounted, computed, watch, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import PropertyDetailContent from '@/components/PropertyDetailContent.vue';
import PropertyCustomerTasksLink from '@/components/PropertyCustomerTasksLink.vue';

interface Props {
  id: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PropertyDetail',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;
const route = useRoute();

const highlightedContactId = ref<number | null>(null);
const contentRef = ref<InstanceType<typeof PropertyDetailContent> | null>(null);
const snackbar = ref(false);
const snackbarMessage = ref('');
const embedDialog = ref(false);
let notificationTimer: ReturnType<typeof setTimeout> | null = null;
watch(snackbar, (show) => {
  if (notificationTimer) clearTimeout(notificationTimer);
  if (show)
    notificationTimer = setTimeout(() => {
      snackbar.value = false;
    }, 3000);
});
onBeforeUnmount(() => {
  if (notificationTimer) clearTimeout(notificationTimer);
});

const embedUrl = computed(() => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/embed/properties/${props.id}/`;
});

const embedCode = computed(() => {
  return `<iframe src="${embedUrl.value}" width="100%" height="800" frameborder="0" style="border: none; min-height: 600px;"></iframe>`;
});

function copyEmbedCode() {
  embedDialog.value = true;
}

async function copyToClipboard(text: string, message: string) {
  try {
    await navigator.clipboard.writeText(text);
    snackbarMessage.value = message;
    snackbar.value = true;
  } catch (err) {
    console.error('Ошибка копирования в буфер обмена:', err);
    snackbarMessage.value = 'Ошибка копирования. Попробуйте еще раз.';
    snackbar.value = true;
  }
}

onMounted(() => {
  const contactIdParam = route.query.contactId;
  if (contactIdParam) {
    highlightedContactId.value = parseInt(contactIdParam as string, 10);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (contentRef.value?.property)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "page-eyebrow" }, "Объект размещения", -1)),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(contentRef.value.property.name), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (contentRef.value.property.wiki_hyperlink)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  "as-child": "",
                  variant: "outline",
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: contentRef.value.property.wiki_hyperlink,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, [
                      _createVNode(_unref(BookOpen), { size: 16 }),
                      _cache[7] || (_cache[7] = _createTextVNode(" Документация ", -1))
                    ], 8, _hoisted_6)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("details", _hoisted_7, [
              _createElementVNode("summary", _hoisted_8, [
                _createVNode(_unref(Ellipsis), { size: 19 })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  class: "justify-start",
                  onClick: copyEmbedCode
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CodeXml), { size: 16 }),
                    _cache[8] || (_cache[8] = _createTextVNode(" Код для встраивания ", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  class: "justify-start",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard(embedUrl.value, 'Ссылка скопирована!')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Link), { size: 16 }),
                    _cache[9] || (_cache[9] = _createTextVNode(" Ссылка на embed ", -1))
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!contentRef.value?.loading && contentRef.value?.property?.customer_tasks?.url)
      ? (_openBlock(), _createBlock(PropertyCustomerTasksLink, {
          key: 1,
          tasks: contentRef.value.property.customer_tasks
        }, null, 8, ["tasks"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Dialog), {
      open: embedDialog.value,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((embedDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogContent), { class: "max-w-2xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("Код для встраивания", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Ссылка и код iframe для документации", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    for: "embed-url",
                    class: "ui-label"
                  }, "Прямая ссылка", -1)),
                  _createVNode(_unref(Button), {
                    size: "sm",
                    variant: "outline",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(embedUrl.value, 'Ссылка скопирована!')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Copy), { size: 14 }),
                      _cache[12] || (_cache[12] = _createTextVNode(" Копировать ", -1))
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(Input), {
                  id: "embed-url",
                  "model-value": embedUrl.value,
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", {
                    for: "embed-code",
                    class: "ui-label"
                  }, "Код iframe", -1)),
                  _createVNode(_unref(Button), {
                    size: "sm",
                    variant: "outline",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (copyToClipboard(embedCode.value, 'Код iframe скопирован!')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Copy), { size: 14 }),
                      _cache[14] || (_cache[14] = _createTextVNode(" Копировать ", -1))
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(Textarea), {
                  id: "embed-code",
                  "model-value": embedCode.value,
                  readonly: "",
                  rows: "4",
                  class: "code-textarea font-mono text-xs"
                }, null, 8, ["model-value"])
              ])
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "outline",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (embedDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("Закрыть", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    (snackbar.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createTextVNode(_toDisplayString(snackbarMessage.value) + " ", 1),
          _createVNode(_unref(Button), {
            variant: "ghost",
            size: "sm",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (snackbar.value = false))
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("Закрыть", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(PropertyDetailContent, {
      ref_key: "contentRef",
      ref: contentRef,
      "property-id": __props.id,
      "highlighted-contact-id": highlightedContactId.value
    }, null, 8, ["property-id", "highlighted-contact-id"])
  ]))
}
}

})